module.exports = __webpack_public_path__ + "img/bg_13.2d8e0aed.png";